import { toWesternDigitsInString } from "src/utils/numberFormat";

/**
 * API `lang=ar` payloads send counts/rates as Eastern Arabic-Indic digit strings
 * (`"٣١"`, `"٢٢٠.٠"`). `Number()`/`parseFloat()` treat those as NaN, so KPI cards
 * fall back to 0. Convert digits first (existing shared helper), then parse.
 */
export const parseApiNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === "" || value === "-") {
    return null;
  }
  if (typeof value === "number") {
    return Number.isFinite(value) ? value : null;
  }

  const western = toWesternDigitsInString(String(value))
    .replace(/٬/g, "")
    .replace(/,/g, "")
    .replace(/٫/g, ".")
    .trim();
  if (!western || western === "-") {
    return null;
  }

  const numeric = Number(western);
  return Number.isFinite(numeric) ? numeric : null;
};
